<script>
export default {
	name: 'ChevronIcon',
	computed: {
		previousQuestionId() {
			return this.$store.state.answers[
				this.$store.state.answers.length - 1
			]?.split('')[0]
		},
		isRouteIntroduction() {
			return (
				this.$route?.name === 'introduction' ||
				this.$route?.name === 'start'
			)
		},
		isRouteFirstQuestion() {
			return this.$route?.params?.id === 'A'
		},
		iconColor() {
			return this.isRouteIntroduction ? 'black' : 'white'
		},
		iconBackgroundColor() {
			return this.isRouteIntroduction
				? 'rgba(255,255,255, 0.7)'
				: 'rgba(0,0,0, 0.4)'
		}
	},
	methods: {
		goToPreviousQuestion() {
			this.$router.push(`/question/${this.previousQuestionId}`)
			this.$store.state.answers.pop()
		}
	}
}
</script>

<template>
	<div
		v-if="!!previousQuestionId"
		class="audio-icon"
		:style="{
			borderColor: iconColor,
			backgroundColor: iconBackgroundColor
		}"
		@click="goToPreviousQuestion()"
	>
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				transform="translate(3, 3)"
				d="M6 13.7979V0.797852M6 0.797852L1 5.79785M6 0.797852L11 5.79785"
				:stroke="iconColor"
			/>
		</svg>
	</div>
</template>

<style lang="sass">
.audio-icon
  display: flex
  justify-items: center
  align-items: center
  cursor: pointer
  border: 1px solid #2D2D2D
  border-radius: 50%
  padding: 15px
</style>
